export default __webpack_public_path__ + "static/media/icon6.4e79d418.svg";